import React, { useState } from 'react';

function SimpleTabs({ tabs, activeTab, setActiveTab }) {
    return (
        <div className="w-full">
            {/* Tab Navigation */}
            <div className="flex border-b border-gray-300">
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        className={`
                            py-2 px-6
                            rounded-t-lg
                            font-normal
                            text-sm
                          
                            text-center
                            ${activeTab === index
                                ? 'text-slate-900 bg-white border-b-2 border-flamingo-500 font-semibold'
                                : 'text-gray-600 bg-gray-100 hover:text-gray-800 hover:bg-gray-200 border-b border-gray-300'
                            }
                        `}
                        onClick={() => setActiveTab(index)}
                        style={{ border: '1px solid #ccc', borderBottom: 'none' }}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div className="mt-4">
                {tabs && tabs[activeTab] && tabs[activeTab].content}
            </div>
        </div>
    );
}

export default SimpleTabs;